import React from "react"
import {
	IconPlusOutline18 as Plus,
	IconTagOutline18 as Tag,
} from "nucleo-ui-outline-18"

import { Button, IconButton } from "@productlane/ui"

interface ChangelogTagSelectTriggerProps {
	hasTags: boolean
}

export const ChangelogTagSelectTrigger = React.memo(
	React.forwardRef<HTMLButtonElement, ChangelogTagSelectTriggerProps>(
		({ hasTags, ...props }, ref) =>
			hasTags ? (
				<IconButton
					ref={ref}
					variant="ghost"
					size="md"
					Icon={Plus}
					iconClassName="size-3.5"
					aria-label="Add label"
					{...props}
				/>
			) : (
				<Button
					ref={ref}
					variant="ghost"
					size="sm"
					Icon={Tag}
					iconClassName="size-3.5"
					className="-ml-2 gap-1.5 px-2 font-normal text-tertiary"
					{...props}
				>
					Add label
				</Button>
			),
	),
)
